
    import "src/app/AppSeller/Orders/ManualOrder/Components/ShippingAddress/index.module.scss?farm_css_modules";
    
    export default {"Checkbox": `Checkbox-d1f900a4`,"shippingAddress": `shippingAddress-d1f900a4`,"subHeading": `subHeading-d1f900a4`}
    